export default "__VITE_ASSET__BDi7K71M__"